import React from 'react';
import cn from 'classnames';
const IconDirectionDown = props => (
  <svg width="1em" height="1em" {...props} viewBox="0 0 14 7" className={cn('pb-core-components-Icon-icon--Icon', 'pb-core-components-Icon-icon--Icon-down')} role="img" focusable="false" aria-hidden="true">
    <defs>
      <polygon id="path-1" points="0 0 14 0 7 7"></polygon>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="My-Applications-(Desktop)" transform="translate(-321.000000, -241.000000)">
        <g id="Content" transform="translate(140.000000, 82.000000)">
          <g id="Table" transform="translate(20.000000, 140.000000)">
            <g id="Customer-table-row-">
              <g id="header">
                <g id="Table">
                  <g id="Table-header-">
                    <g>
                      <g>
                        <g id="Customer-table-row-">
                          <g>
                            <g>
                              <g id="Tables-Display/Size:S6/Header-Example/RScale:2">
                                <g id="System-icons/-Filter-down-/" transform="translate(161.000000, 19.000000)">
                                  <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-1"></use>
                                  </mask>
                                  <use id="New" fill="#767676" fillRule="evenodd" xlinkHref="#path-1"></use>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default React.memo(IconDirectionDown);
